module.exports = __webpack_public_path__ + "img/f7d5b9fb0c4cc0aa7fd081370d07157c.png";